import React from "react";
import "./App.css";
import { CartProvider, useCart } from "./context/CartContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Shop from "./components/Shop";
import Customizer from "./components/Customizer";
import Game from "./components/Game";
import { Repairs, Contact } from "./components/RepairsContact";
import CartDrawer from "./components/CartDrawer";

function Toast() {
  const { toastMsg, toastShow } = useCart();
  return <div className={"toast" + (toastShow ? " show" : "")} role="status" aria-live="polite">{toastMsg}</div>;
}

function Site() {
  return (
    <>
      <Header />
      <main id="top">
        <Hero />
        <Shop />
        <Customizer />
        <Game />
        <Repairs />
        <Contact />
      </main>
      <CartDrawer />
      <Toast />
    </>
  );
}

function App() {
  return (
    <CartProvider>
      <Site />
    </CartProvider>
  );
}

export default App;
